export const atSymbolTrigger = /(?:\s|&nbsp;|\n|<br>)@(?=\s|&nbsp;)|(?:\s|&nbsp;|\n|<br>)@$|^@$/;
